import { Divider } from "@material-ui/core";
import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const GoalDescriptionInput = ({
  handleGoalDescription,
  input,
  characterLimit,
}) => {
  const { t } = useContext(TMDataContext);
  return (
    <div className="goal-boxed-input-area">
      <div className="goal-form-input-row" style={{ marginBottom: "-10px" }}>
        <label
          htmlFor="goal-description-input"
          className="goal-input-area-title"
        >
          {t("views.goals.headings.description")}
        </label>
        <div className="goal-title-input-wrap">
          <textarea
            className="goal-title-input-field"
            style={{ minHeight: "100px" }}
            id="goal-description-input"
            autoComplete="none"
            maxLength={characterLimit}
            onChange={handleGoalDescription}
            value={input}
            name="goal-description"
          />
          <span
            className="goal-title-character-count"
            style={{ float: "right" }}
          >
            {input.length}/{characterLimit}
          </span>
        </div>
      </div>
    </div>
  );
};
